import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CorporateEventsBanner from "../../../../components/reusable-components/b2b/corporate-events-banner/CorporateEventsBanner";
import CorporateEventGrid from "../CorporateEventsGrid";
import { useAppDispatch, useAppSelector } from "../../../../hooks/storeHooks";
import { getCorporateEventsHistoryThunk } from "../../../../store/b2b/corporateEvent/corporateEventThunk";
import IsMobile from "../../../../hooks/isMobile";
import { getCorporateApprovedEventsListColumns } from "../../../../utils/B2B/corporateEventsUtils";
import { ROUTE_QUERY_CONSTANTS } from "../../../../routes";
import { EVENT_TYPE_HISTORY } from "../../../../types/eventTypes";
import { GridIdsEnum } from "../../../../constants/enums";
import { useOnUpdateUserEvents } from "../../../../hooks/firestoreHooks/eventListUpdateHook";

const CompletedEvents = () => {
	const dispatch = useAppDispatch();
	const isMobile = IsMobile();
	const { corporateEvents } = useAppSelector((state) => state.corporateEvent);
	const [shouldStartUpdating, setShouldStartUpdating] = useState(false);
	const columns = getCorporateApprovedEventsListColumns();

	const fetchEventListData = () => {
		dispatch(getCorporateEventsHistoryThunk(EVENT_TYPE_HISTORY.COMPLETED));
		setShouldStartUpdating(true);
	};

	useOnUpdateUserEvents(shouldStartUpdating, fetchEventListData);

	useEffect(() => {
		fetchEventListData();
	}, []);

	return (
		<Box className="content">
			<CorporateEventsBanner subtitle="Corporate Completed Events" />
			<Box
				className="pageLayout"
				sx={{
					display: "flex",
					flexDirection: isMobile ? "column-reverse" : "column",
					paddingTop: "0px !important"
				}}>
				<CorporateEventGrid
					corporateEventList={corporateEvents}
					columns={columns}
					title="Completed Events"
					queryParams={ROUTE_QUERY_CONSTANTS.CorporateCompletedEvents}
					gridId={GridIdsEnum.CORPORATE_EVENTS_COMPLETED}
					message="No completed events yet."
				/>
			</Box>
		</Box>
	);
};

export default CompletedEvents;
